import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './descriptions.vdt';
import { useConfigContext } from '../config';
import { VNode } from 'intact-vue-next';
var typeDefs = {
  vertical: Boolean,
  columns: Number,
  items: Array,
  title: [String, Number, VNode]
};
var defaults = function defaults() {
  return {
    columns: 3
  };
};
export var Descriptions = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Descriptions, _Component);
  function Descriptions() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  return Descriptions;
}(Component);
Descriptions.template = template;
Descriptions.typeDefs = typeDefs;
Descriptions.defaults = defaults;